export { IndexMapper } from './indexMapper';
export { getRegisteredMapsCounter } from './mapCollections/mapCollection';
export { getIncreasedIndexes, getDecreasedIndexes, alterUtilsFactory } from './maps/utils';
export * from './maps';
